import o from "./Layout.vue2.js";
import t from "../_virtual/_plugin-vue_export-helper.js";
const _ = /* @__PURE__ */ t(o, [["__scopeId", "data-v-9310778b"]]);
export {
  _ as default
};
